const promise = new Promise(res => {
  window.addEventListener('message', event => {
    if (typeof event.data === 'object' && event.data.m === 'chart') {
      res(event.data.d)
    }
  })
})

export default promise
